import { Environment } from '@sg/common';
import { BehaviorSubject } from 'rxjs';
import { oidcUriNormalizer } from '../utils';
import type { SgApplicationConfiguration } from './types';

const PATHNAME_APP_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-emt)(?:/|\\?|().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^emt(?:-.*)?\\.sharegain\\.com$`);

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-emt': {}
  }
}

export const sgNewAdmin: SgApplicationConfiguration<'sg-emt'> = {
  name: 'sg-emt',
  authType: 'oidc',
  branding: {
    hideTopBar: true,
    hideActionsMenu: true,
    showBurgerMenu: false,
    showSideBarExpender: true,
    initialSideNavMode: new BehaviorSubject('side'),
    disableCloseSideNav: true,
    logo: 'assets/images/white-sharegain-logo.svg',
    showAppName: true,
    navBarLogoSrc: 'assets/images/logos/sharegain_logo.svg',
    navBarHomeLink: '',
    showLogo: true,
    appName: 'EMT',
    expanderPosition: 'bottom',
    isFloatingSideBar: true,
    showUserMenu: true,
    showNotifications: false,
  },
  matcher: (location: Location) => {
    return PATHNAME_APP_DETECT_REGEXP.test(location.pathname)
      || PATHNAME_APP_DETECT_REGEXP.test(location.hash)
      || HOSTNAME_DETECT_REGEXP.test(location.hostname);
  },
  beforeLogin(env: Environment) {
    const { oidc } = env;
    env.oidc.acr_values = 'tenant:Admin idp:aad';

    // by default, OIDC redirects are set under the assumption of a path app (hostname.com/SG-APPNAME)
    // when it's not the case we need to set the redirects properly.
    if (!PATHNAME_APP_DETECT_REGEXP.test(location.pathname) && !PATHNAME_APP_DETECT_REGEXP.test(location.hash)) {
      oidcUriNormalizer(oidc);
    }
  },
}
